<template>
  <div class="modal">

    <div class="container">
      <button
        type="button"
        @click="$emit('close')"
        class="modal__close"
      >
        <slot/>
      </button>
      <div 
        class="modal__content"
        v-html="content"
      ></div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String
    }
  }
};
</script>

<style lang="sass">
  @import '@/assets/sass/partials/_sass-components.sass'
  .modal
    position: fixed
    text-align: left
    z-index: 100
    width: 100%
    height: 100%
    color: #282830
    font-weight: 300
    top: 0
    left: 0
    padding: 67px 0
    background-color: white
    overflow-y: scroll
    -webkit-overflow-scrolling: touch
    +res('mob')
      padding: 30px 15px
    &__content
      padding-top: 50px
      font-family: $text-font-book
    .container
      position: relative
    h1,h2 
      text-transform: uppercase
    h1 
      font-family: $text-font-book
      font-size: 44px
      line-height: 48px
      font-weight: 400
      color: $black
      text-transform: uppercase
      +res('mob')
        font-size: 34px
        line-height: 40px
    h2
      font-family: $primary-font
      font-size: 34px
      line-height: 40px
      color: $black
      font-weight: 400
      text-transform: uppercase
      +res('mob')
        font-size: 22px
        line-height: 28px
    h3
      font-family: $font-semibold
      font-size: 22px
      font-weight: 400
      line-height: 28px
      color: $black
      +res('mob')
        font-size: 16px
        line-height: 24px
    h4
      font-family: $text-font
      font-size: 22px
      font-weight: 400
      line-height: 28px
      color: $black
      +res('mob')
        font-size: 16px
        line-height: 24px
    h5
      font-family: $font-semibold
      font-size: 16px
      font-weight: 400
      line-height: 1.36
      color: $black
    ul,ol
      padding-left: 20px
      font-weight: 300
      line-height: 1.6
    li
      margin-bottom: 20px
      font-weight: 300
      font-size: 16px
    p
      margin-bottom: 20px
      font-family: $text-font-book
    strong
      font-family: $font-semibold
    a 
      font-size: 16px
      color: $black
      font-family: $text-font-book
      +res('desk')
        &:hover
          color: #d90022
    &__close
      position: absolute
      cursor: pointer
      // width: 30px
      height: 48px
      padding: 0 33px
      border-radius: 24px
      font-family: $text-font-book
      font-size: 15px
      background-color: $black
      color: #fff
      right: 0px
      top: 0
      border: none
      outline: none
      // &::before,&::after
      //   width: 20px
      //   height: 2px
      //   left: 5px
      //   top: 13px
      //   content: ''
      //   position: absolute
      //   background-color: #6c7073
      //   transform: rotate(45deg)
      // &:after
      //   transform: rotate(-45deg)
      +res('mob')
        right: 0
      +res('desk')
        right: 15px
</style>
